import React from "react";
import { Modal, Button } from "react-bootstrap";

function RecuperarPasswordModal({
  show,
  onHide,
  tipoAcceso,
  email = "",
}) {
  const emailLimpio = email.trim();
  const contactoEmail = "colegiosantotomasageneral@gmail.com";
  const telefono = "2654313911";
  const telefonoVisual = "2654-313911";

  const mensaje = `Hola, necesito recuperar mi contraseña de ${tipoAcceso}. Mi correo es ${emailLimpio || "[completar correo]"}.`;
  const mailtoHref = `mailto:${contactoEmail}?subject=${encodeURIComponent(
    `Recuperación de contraseña - ${tipoAcceso}`
  )}&body=${encodeURIComponent(mensaje)}`;
  const whatsappHref = `https://wa.me/54${telefono}?text=${encodeURIComponent(
    mensaje
  )}`;

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Recuperar contraseña</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-3">
          Te ayudamos a recuperar el acceso a <strong>{tipoAcceso}</strong>.
        </p>
        <p className="mb-3">
          Contactanos por cualquiera de estas vías y el mensaje ya saldrá
          preparado con tus datos.
        </p>
        <div className="bg-light rounded-4 p-3 mb-3">
          <div className="small text-muted">Email de contacto</div>
          <div className="fw-semibold">{contactoEmail}</div>
        </div>
        <div className="bg-light rounded-4 p-3">
          <div className="small text-muted">WhatsApp</div>
          <div className="fw-semibold">{telefonoVisual}</div>
        </div>
      </Modal.Body>
      <Modal.Footer className="justify-content-between">
        <Button variant="outline-secondary" onClick={onHide}>
          Cerrar
        </Button>
        <div className="d-flex gap-2">
          <Button as="a" href={mailtoHref} variant="outline-success">
            Enviar email
          </Button>
          <Button
            as="a"
            href={whatsappHref}
            target="_blank"
            rel="noreferrer"
            variant="success"
          >
            WhatsApp
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default RecuperarPasswordModal;
